import * as KatalMetrics from '@amzn/katal-metrics';
import { MetricName, Pages } from 'src/constants/metrics';
import metricsPublisher from 'src/utils/metricsPublisher';

export type InitializationStatus = 'success' | 'failure';
export default class ApplicationMetrics {
  protected actionPublisher: KatalMetrics.Publisher;

  protected intializationPublisher: KatalMetrics.Publisher;

  constructor(methodName: string = 'SELLER_FORUMS') {
    this.intializationPublisher = metricsPublisher()!.newChildActionPublisherForInitialization();
    this.actionPublisher = metricsPublisher()!.newChildActionPublisherForMethod(methodName);
  }

  public publishCounterMetric(metricName: string, countValue: number) {
    this.actionPublisher.publishCounterMonitor(metricName, countValue);
  }

  public publishString(metricName: string, metricValue: string) {
    this.actionPublisher.publishString(metricName, metricValue);
  }

  public publishInitializationMetric(status: InitializationStatus) {
    const initializationMetric = new KatalMetrics.Metric.Initialization().withMonitor();
    initializationMetric.setFailure(status !== 'success');
    this.intializationPublisher.publish(initializationMetric);
  }

  public publishPageLoad(page: Pages) {
    this.actionPublisher.publishCounterMonitor(page, 1);
  }

  public getActionPublisher() {
    return this.actionPublisher;
  }

  public publishHttpRequestMetric(
    url: string,
    response: Response,
    isSuccess: boolean,
  ) {
    const metric = new KatalMetrics.Metric.HttpRequest(MetricName.fetchRequest).withMonitor();

    // katal metrics client has a max character limit on URL
    metric.url = url.slice(0, 256);
    if (isSuccess) {
      metric.statusCode = response.status;
      metric.statusText = response.statusText;
      metric.setSuccess();
    } else {
      metric.setFailure();
    }
    this.actionPublisher.publish(metric);
  }
}
